import axios from 'axios';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import HeadOrderDetails from '../SharedModule/HeadOrderDetails';
import SideOrderDetails from '../SharedModule/SideOrderDetails';

export default function CheckAfter() {

    const { user } = useSelector((state) => state.auth);
  
    const token = user?.token;
  
    const baseUrl = "https://estbn.com/EstbnNew/public";

    const { id } = useParams();
        
    const navigate = useNavigate();

  const goToOrderDetails = () => {
        navigate(`/orders/${id}`);
    };

    const goToActivityDetails = () => {
            navigate(`/Activity/${id}`);
    };

    const goToComments = () => {
        navigate(`/comments/${id}`);
    };

    const goToCheckBefore = () => {
        navigate(`/checkBefore/${id}`);
  };
  
    const goToReviews = () => {
      navigate(`/ordReviews/${id}`);
    };

    const [imagesData, setImagesData] = useState([]);

    const getImages = async () => {
      try {
        let response = await axios.get(
          `${baseUrl}/api/portal/get-after-images/${id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        console.log(response.data.data.images_after);
        setImagesData(response.data.data.images_after);
      } catch (error) {
        console.log(error.message);
      }
    };

    useEffect(() => {
      getImages();
    }, []);

 return (
   <>
     {/* Head Details */}
     <HeadOrderDetails />
     {/* Details Filteration */}
     <div className="details-filter mx-4">
       <button onClick={goToOrderDetails} className="btn">
         Order Details
       </button>
       <button onClick={goToActivityDetails} className="btn ">
         Activity logs
       </button>
       <button className="btn" onClick={goToComments}>
         Client Comments
       </button>
       <button className="btn" onClick={goToCheckBefore}>
         Check Body Before
       </button>
       <button className="btn bg-black text-white">Check Body After</button>
       <button className="btn" onClick={goToReviews}>
        Reviews
       </button>
     </div>
     {/* Comments Details  */}
     <div className=" Comments Details">
       <div className="row m-4 justify-content-between">
         <div className="col-sm-12 col-md-8 border border-1 rounded-2 ">
           <div className="px-2 py-3 border-bottom border-2">
             <h3 className="pt-2">Car Parts After</h3>
           </div>
           {/* images of the car  */}
           <div
             className="px-3 py-3 scrollable-div"
             style={{ height: "715px", overflow: "auto" }}
           >
             {imagesData.map((img) => (
               <div
                 key={img.id}
                 style={{
                   margin: "15px 0px",
                   width: "100%",
                   height: "180px",
                   position: "relative",
                 }}
                 className="border border-2 rounded-3 d-flex justify-content-evenly align-items-center py-3"
               >
                 {/* image */}
                 <div
                   className="col-3 d-flex justify-content-center align-items-center rounded-3"
                   style={{ border: "2px dashed lightgrey", height: "130px" }}
                 >
                   <img
                     src={`${baseUrl}${img.image_url}`}
                     alt={img.config?.label_ar}
                     style={{
                       width: "100%",
                       height: "120px",
                       objectFit: "contain",
                       borderRadius: "6px",
                       cursor: "pointer",
                       padding: "5px",
                     }}
                   />
                 </div>

                 {/* label & description */}
                 <div
                   className="col-8 bg-light border border-light d-flex flex-column align-items-start justify-content-start rounded-3 p-3"
                   style={{ height: "130px" }}
                 >
                   <div className="d-flex align-items-center gap-3">
                     <label className="fw-bold">{img.config?.label_ar}</label>

                     <span style={{ fontSize: "13px", color: "#777" }}>
                       {new Date(img.created_at).toLocaleDateString("en-GB")}
                       {"  "}
                       {new Date(img.created_at).toLocaleTimeString([], {
                         hour: "2-digit",
                         minute: "2-digit",
                       })}
                     </span>
                   </div>

                   <label className="fw-semibold my-2">{img.description}</label>
                 </div>
               </div>
             ))}
           </div>
         </div>
         {/* SideOrderDetails  */}
         <SideOrderDetails />
       </div>
     </div>
   </>
 );
}
